<template>
  <div class="demo-container">
    <h2>轮播弹窗组件演示</h2>
    <van-button type="primary" @click="showCarousel">显示轮播弹窗</van-button>
    
    <!-- 轮播弹窗组件 -->
    <welcome-carousel
      :visible="carouselVisible"
      @close="handleCarouselClose"
      @start="handleCarouselStart"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { Button, Toast } from 'vant';
import WelcomeCarousel from './WelcomeCarousel.vue';

Vue.use(Button);

export default {
  name: 'WelcomeCarouselDemo',
  components: {
    WelcomeCarousel
  },
  data() {
    return {
      carouselVisible: false
    };
  },
  methods: {
    showCarousel() {
      this.carouselVisible = true;
    },
    handleCarouselClose() {
      this.carouselVisible = false;
      Toast('轮播弹窗已关闭');
    },
    handleCarouselStart() {
      Toast('用户点击了立即开启');
      // 这里可以添加跳转逻辑或其他操作
    }
  }
};
</script>

<style lang="less" scoped>
.demo-container {
  padding: 20px;
  text-align: center;
}
</style> 